// Redirect old primvoices.com domains to voicerun.com
if (window.origin === "https://app.primvoices.com") {
  window.location.href = window.location.href.replace("https://app.primvoices.com", "https://app.voicerun.com");
} else if (window.origin === "https://app-dev.primvoices.com") {
  window.location.href = window.location.href.replace("https://app-dev.primvoices.com", "https://app-dev.voicerun.com");
}

let apiUrl = "";
let googleOauthUrl = "";
let stripePublishableKey = "";
let transcribeWsUrl = "";

switch (window.origin) {
  case "http://localhost:3000":
    apiUrl = "http://localhost:8080";
    googleOauthUrl = "https://test.stytch.com/v1/public/oauth/google/start?public_token=public-token-test-e6e70c31-a728-4408-b66a-72d4a3b24492";
    stripePublishableKey = "pk_test_51SxwwIGtOBpW6CsHKFMaKmxMW1UF5wAJAS2cixslwreh3bmoqEFmtpNgwtdlwFnYt08ah1KEGtBpc0ybLtYRsmoC00hwPXmZWP";
    transcribeWsUrl = "ws://localhost:8083/ws";
    break;
  case "https://app-dev.voicerun.com":
    apiUrl = "https://api-dev.voicerun.com";
    googleOauthUrl = "https://test.stytch.com/v1/public/oauth/google/start?public_token=public-token-test-e6e70c31-a728-4408-b66a-72d4a3b24492";
    stripePublishableKey = "pk_test_51SxwwIGtOBpW6CsHKFMaKmxMW1UF5wAJAS2cixslwreh3bmoqEFmtpNgwtdlwFnYt08ah1KEGtBpc0ybLtYRsmoC00hwPXmZWP";
    transcribeWsUrl = "wss://transcribe-dev.voicerun.com/ws";
    break;
  case "https://app.voicerun.com":
    apiUrl = "https://api.voicerun.com";
    googleOauthUrl = "https://api.stytch.primvoices.com/v1/public/oauth/google/start?public_token=public-token-live-6127898b-3b79-4918-b74e-7e66c51e51c6";
    stripePublishableKey = "pk_live_51SxwwIGtOBpW6CsHIdlNoXxhK06BrniOyz7wQnFFedB3P3lfVdXaQc079Zls0HnSKkeDSr4lSVE7ALyOy4UUoZiu0040SyknZ5";
    transcribeWsUrl = "wss://transcribe.voicerun.com/ws";
    break;
  default:
    apiUrl = window.origin.replace("3000", "8080");
    break;
}

export const API_URL = apiUrl;
export const GOOGLE_OAUTH_URL = googleOauthUrl;
export const STRIPE_PUBLISHABLE_KEY = stripePublishableKey;
export const TRANSCRIBE_WS_URL = transcribeWsUrl;
